import React, { Component } from 'react';
import { Spin } from 'antd';
import { api } from '@comall-backend-builder/core/lib/services';
import { Image } from '@comall-backend-builder/components-basis';
import { errorHandle } from '../../services';

interface WelcomeStates {
    imgUrl: null | string;
    spinning: boolean;
}

export class Welcome extends Component<any, WelcomeStates> {
    state = {
        imgUrl: null,
        spinning: false
    };

    componentDidMount() {
        this.setState({ spinning: true });
        api.get({}, { apiPath: '/homepage/welcome', apiRoot: ENV.API_ROOT }).then((data: any) => {
            this.setState({
                imgUrl: data && data.imgUrl
            });
        })
        .catch(errorHandle)
        .finally(() => {
            this.setState({ spinning: false });
        });
    }
    
    render() {
        let { imgUrl, spinning } = this.state;
        const props = {
            text: '品真阁',
            style: {
                width: '100%'
            }
        };
        return (
            <Spin spinning={spinning}>
                {imgUrl ? (<Image imageurl={imgUrl!} {...props} />) : null}
            </Spin>
        );
    }
}
